import merge from 'classnames';

import { IconBoldCheckMark } from '@/components/icons/IconBoldCheckMark';

import { ButtonGroupProps } from './types';

import styles from './ButtonGroup.module.scss';

export const ButtonGroup = ({ buttons, active, classes, onSelect }: ButtonGroupProps) => (
  <div className={styles.group} data-testid="gafe-button-group">
    {buttons.map(({ label, value, icon }, index) => (
      <button
        aria-label={label}
        className={merge(
          styles.button,
          {
            [styles.active]: value === active,
            [styles.remove_right_border]:
              index === buttons.length - 2 && active === buttons[index + 1].value,
          },
          classes?.button,
        )}
        key={label}
        onClick={() => onSelect(value)}
        type="button"
      >
        <div className={styles.button_content}>
          <div className={styles.icon_wrapper}>
            <div className={merge(styles.icon, { [styles.icon_show]: value === active })}>
              <IconBoldCheckMark color="#2774ae" />
            </div>
            <div className={merge(styles.icon, { [styles.icon_show]: value !== active })}>
              {icon}
            </div>
          </div>
          <span>{label}</span>
        </div>
      </button>
    ))}
  </div>
);
